import { MediaMatcher } from "@angular/cdk/layout";
import { Component, OnInit, ViewChild, ViewContainerRef, ChangeDetectorRef } from "@angular/core";
import { LayerService } from "src/app/features/map-features/sections/locations-section/services/Layers.service";
import { ToolCarsSelectorService } from "src/app/features/pages/maps/services/Tool-Cars-Selector.service";
import { NavHeaderService } from "src/app/features/ui/organisms/header/service/nav-header.service";
import { MAP_BUILD_NAMES } from "src/models/common/EnumMapas";
import { InfoBoxMapService } from "src/services/maps/features/InfoBox-Map.service";
import { LocationsMapService } from "src/app/features/map-features/sections/locations-section/services/LocationsMap.service";
import { BaseMapService } from "../../services/BaseMap.service";
import { FULL_TOOLS_ALLOWED, ToolsEnum } from "../../utils/enums/toolsEnum";
import { LocalStorageService } from "src/app/features/shared/services/LocalStorage.service";
import { AllowedDTO } from "../../utils/models/allowedDTO";
import { DetailsPanelAllowanceEnum, FULLY_ALLOWED_DETAILS_PANEL } from "../../utils/enums/detailsPanelAllowanceEnum";
import { MapRestrictionsService } from "../../services/MapRestrictions.service";
import { RouteSheetUtilService } from "src/app/features/map-features/ui/organisms/route-sheet/service/RouteSheetUtil.service";

@Component({
  selector: 'app-unified-map',
  templateUrl: './unified-map.component.html',
  styleUrls: ['./unified-map.component.css']
})
export class UnifiedMapComponent implements OnInit{

  allowedParts: AllowedDTO = { 
    allowedTools: FULL_TOOLS_ALLOWED,
    allowedCategories: [],
    allowedFeaturesDetailsPanel: FULLY_ALLOWED_DETAILS_PANEL
  };

  @ViewChild('dynamicComponentContainer', { read: ViewContainerRef, static: true })
  carouselViewContainerRef!: ViewContainerRef;
  
  selectedPanel: any;

  //Variables para tooltip
  intersectMsg: string = "Selecciona varios puntos en el mapa para crear la SELECCIÓN DE UNIDADES. Para finalizar da click derecho sobre el mapa.";

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  
  MAP_BUILD_NAMES: any = MAP_BUILD_NAMES;

  constructor(
    private locationsMapService: LocationsMapService,
    private routeSheetUtilService: RouteSheetUtilService,
    private navHeaderService: NavHeaderService,
    public infoBoxMapService: InfoBoxMapService,
    public toolCarSelectorService: ToolCarsSelectorService,
    public localStorageService: LocalStorageService,
    media: MediaMatcher,
    changeDetectorRef: ChangeDetectorRef,
    public layerService: LayerService,
    private mapRestrictionsService: MapRestrictionsService
    ){
      this.mobileQuery = media.matchMedia("(min-width: 761px)");
      this._mobileQueryListener = () => changeDetectorRef.detectChanges();
      this.mobileQuery.addListener(this._mobileQueryListener);
    
  }
  
  ngOnInit(){
    
    //añadir cosas el unified
    this.InitialiceMapComponents();
    this.checkAllowedCategories();
    this.mapRestrictionsService.allowedParts$.next(this.allowedParts);
  }

  ngAfterViewInit(): void {
    this.navHeaderService.CheckMapPaneles("locationsMap");
  }

  onToolTipVisibilityChange(isVisible: boolean) {
    this.toolCarSelectorService.isCarSelectionToolTipVisible = isVisible;
  }

  InitialiceMapComponents(){
    this.locationsMapService.setCarouselViewContainerRef(this.carouselViewContainerRef);
    this.routeSheetUtilService.setCarouselViewContainerRef(this.carouselViewContainerRef);
  }

  checkAllowedCategories(){
    const params = JSON.parse(localStorage.getItem("queryParams") || "{}");
    this.allowedParts.allowedCategories = params['idCategories'] ? params['idCategories'].split(',') : [];

    console.log("allowed", this.allowedParts);
    

    if(this.allowedParts.allowedCategories.length === 0){
      const categories = JSON.parse(this.localStorageService.getListaCategorias() || "[]");
      this.allowedParts.allowedCategories = categories.map((cat: any) => cat.id.toString());
      this.allowedParts.allowedCategories.push("gps");
    console.log("allowed", this.allowedParts);
    }
  }

}
